import { render } from "./PropertyChangelist.vue?vue&type=template&id=5a566455"
import script from "./PropertyChangelist.vue?vue&type=script&lang=js"
export * from "./PropertyChangelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__